const MONTHS = [
	'января',
	'февраля',
	'марта',
	'апреля',
	'мая',
	'июня',
	'июля',
	'августа',
	'сентября',
	'октября',
	'ноября',
	'декабря'
]

const isSameDay = (first: Date, second: Date) =>
	first.getFullYear() === second.getFullYear() &&
	first.getMonth() === second.getMonth() &&
	first.getDate() === second.getDate()

const formatTime = (date: Date) =>
	`${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`

export const formatReviewDate = (value: string, now = new Date()) => {
	if (!/^\d{4}-\d{2}-\d{2}T/.test(value)) return value

	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return value

	if (isSameDay(date, now)) return `Сегодня, ${formatTime(date)}`

	const yesterday = new Date(now)
	yesterday.setDate(now.getDate() - 1)
	if (isSameDay(date, yesterday)) return `Вчера, ${formatTime(date)}`

	return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`
}
